import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1b52e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "despedida position-absolute w-100 h-100 d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "row g-0 text-center justify-content-center align-items-center" }
const _hoisted_3 = { class: "col-12 px-3 col-lg-6 mb-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1))
const _hoisted_6 = { class: "col-12 px-3 col-lg-6" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.logo,
          width: "250"
        }, null, 8, _hoisted_4)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", { innerHTML: _ctx.mensaje }, null, 8, _hoisted_7)
      ])
    ])
  ]))
}